import React, { FC, ChangeEvent, useRef, useEffect } from "react";

import styles from "./TextField.module.scss";

type Props = {
  id: string;
  label: string;
  value: string;
  placeholder: string;
  onChange: (e: ChangeEvent<HTMLTextAreaElement>) => void;
};

const TextField: FC<Props> = ({ id, label, value, placeholder, onChange }) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = "auto";
      textarea.style.height = `${textarea.scrollHeight}px`;
    }
  }, [value]);

  return (
    <div className={styles.field}>
      <label className={styles.label} htmlFor={id}>
        {label}
      </label>
      <textarea
        ref={textareaRef}
        className={styles.input}
        id={id}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        rows={1}
      />
    </div>
  );
};

export default TextField;
